<span class="select-all" (click)="onClick()">Select All</span>
